<template>
  <div class="indicators-scores-block" aria-hidden="true">
    <div v-for="(indicator, index) in indicators" 
      :key="indicator.name"
      class="current-indicator-row">
      <div class="indicator-score"><color-block 
        :score="indicatorsColumnA[index].score"
        :isHovered="false"
        :name="`column B ${indicator.name}`">
        </color-block>
      </div>
      <div class="indicator-score"><color-block 
        :score="indicatorsColumnB[index].score"
        :isHovered="false"
        :name="`column B ${indicator.name}`">
        </color-block>
      </div>
      <div class="current-indicator-name">{{indicator.name}}</div>
    </div>
  </div>
</template>

<script>
import MapColorBlock from '../MapColorBlock';
import { setAria } from '../../helpers/openCloseHelpers';

export default {
  name: 'indicator-score-block',
  props: ['indicators', 'indicatorsColumnA', 'indicatorsColumnB', 'showIndicators'],
  components: {
    'color-block': MapColorBlock,
  },
  watch: {
    showIndicators: setAria,
  },
};
</script>

<style lang="less">
  .current-indicator-row {
    display:flex;
    min-height: 26px;
    padding: 3px 0 3px 10px;
    box-sizing: border-box;
    @media(max-width: 800px) {
      flex-wrap: wrap;
    }
  }
  .indicator-score {
    height: 20px;
    flex: 0 0 90px;
    box-sizing: border-box;
    padding: 0 5px;

    @media(max-width: 700px) {
     flex: 0 1 48%;
     height: 30px;
     margin-top: 4px;
     height: 40px;
    }
    @media(max-width: 500px) {
      flex: 0 1 45%;
    }
  }
  .current-indicator-name {
    white-space: nowrap;
    @media(max-width: 800px) {
     flex: 0 0 100%;
      order: -1;
    }
    @media (min-width: 700px) and (max-width: 800px) {
      white-space: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// IndicatorScoreBlock.vue?4deb59ec